var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashfull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14.077,
    viewBox: "0 0 14.077 14.077",
    width: 14.077,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.352 3h-13c-.237 0 .173-.831 0-1s0 .241 0 0-.173-.827 0-1-.237 0 0 0h5c0-.237-.169-.827 0-1s.754 0 1 0h1c.246 0 .831-.173 1 0s0 .763 0 1h5c.237 0-.173-.173 0 0s1 .758 1 1-.827-.168-1 0 .237 1 0 1zm-12 1h11c.237 0-.173-.173 0 0s1-.237 1 0v8c0 .483-.658.658-1 1s-.517 1-1 1h-9c-.483 0-.658-.658-1-1s-1-.517-1-1v-8c0-.237.827.173 1 0s-.237 0 0 0z",
    fill: "#3c2f87",
    transform: "translate(-.275 .077)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashfull);
export default __webpack_public_path__ + "static/media/trashfull.2c9b6f15bac7ee55ea73cfd6f6936fde.svg";
export { ForwardRef as ReactComponent };